import type { FilterDefinitionValue } from "@/pages/(app)/returns/hooks/use-filter-definitions";
import ConditionFilterCommand from "@/pages/(app)/returns/list/components/commands/condition-filter-command";
import StringArrayFilterCommand from "@/pages/(app)/returns/list/components/commands/string-array-filter-command";
import FacetedFilter from "@/pages/(app)/returns/list/components/faceted-filter/faceted-filter";
import type { StringFrontFilterValue } from "@/pages/(app)/returns/providers/return-requests-filters.provider";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import useTranslation from "@babackapp/translations/use-translation";
import { StringFilterName } from "../../utils/types";

interface StringFacetedFilterProps {
  filterDefinition: FilterDefinitionValue;
  filter: StringFrontFilterValue;
  filterName: StringFilterName;
}

export default function StringFacetedFilter({
  filterDefinition,
  filter,
  filterName,
}: StringFacetedFilterProps) {
  const { clearFilter } = useReturnRequestsFilters();
  const t = useTranslation();

  const values = filter.value.slice(0, 3);
  let valueLabel = filterDefinition.options.get(values[0])!.label;

  if (values.length > 1) {
    valueLabel = `${filter.value.length} ${filterDefinition.category.labelPlural.toLowerCase()}`;
  }

  return (
    <FacetedFilter
      categoryProps={{
        label: filterDefinition.category.label,
        Icon: filterDefinition.category.Icon,
      }}
      typeProps={{
        label: t(`misc.filters.${filter.condition}`, {
          count: filter.value.length,
        }),
        children: (
          <ConditionFilterCommand
            conditionsOptionValues={["in", "notIn"]}
            value={filter.condition}
            filterKey={filterName}
          />
        ),
      }}
      valueProps={{
        label: valueLabel,
        icons: values
          .map((value) => filterDefinition.options.get(value)!.Icon)
          .filter((icon) => !!icon),
        children: (
          <StringArrayFilterCommand
            filterDefinition={filterDefinition}
            filter={filter as StringFrontFilterValue}
            filterKey={filterName}
          />
        ),
      }}
      onClearClick={() => {
        clearFilter({ name: filterName });
      }}
    />
  );
}
